import { render, staticRenderFns } from "./BottomSlidePopup.vue?vue&type=template&id=e45540d2&scoped=true"
import script from "./BottomSlidePopup.vue?vue&type=script&lang=js"
export * from "./BottomSlidePopup.vue?vue&type=script&lang=js"
import style0 from "./BottomSlidePopup.vue?vue&type=style&index=0&id=e45540d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45540d2",
  null
  
)

export default component.exports